import React from 'react';
import { Question } from '@app/modules/checklist/components/checklist-item/checklist-item.styled';
var HTMLDisplayToQuestion = function (_a) {
    var htmlContent = _a.htmlContent;
    var isHTML = function (str) { return /<\/?[a-z][\s\S]*>/i.test(str); };
    return isHTML(htmlContent) ? (React.createElement(Question, { dangerouslySetInnerHTML: { __html: htmlContent } })) : (React.createElement(Question, null, htmlContent));
};
export default HTMLDisplayToQuestion;
